import type { ReactNode } from "react";
import type { NetworkEnv } from "@/network/env";
import { setNetworkEnv } from "@/network/env";

export type ShellProps = {
  title: string;
  networkEnv: NetworkEnv;
  onNetworkEnvChange: (env: NetworkEnv) => void;
  sessionOn: boolean;
  navPad?: boolean;
  username?: string;
  onLogout: () => void;
  children: ReactNode;
};

export function Shell({
  title,
  networkEnv,
  onNetworkEnvChange,
  sessionOn,
  navPad = true,
  username,
  onLogout,
  children,
}: ShellProps) {
  return (
    <div className="phone-frame" aria-label="Nanom Wallet">
      <div className={`shell${navPad ? " session-on" : " auth-only"}`}>
        <header className="top wx-top">
          <div className="top-brand">
            <span className="wx-logo" aria-hidden="true">
              N
            </span>
            <div className="top-brand-text">
              <span className="wx-brand-name">NANOM</span>
              <h1 className="top-title">{title}</h1>
            </div>
          </div>
          <div className="top-cluster">
            <div className="net-switch" role="group" aria-label="network">
              <button
                type="button"
                className={networkEnv === "testnet" ? "net-btn active" : "net-btn"}
                onClick={() => {
                  setNetworkEnv("testnet");
                  onNetworkEnvChange("testnet");
                }}
              >
                تست‌نت
              </button>
              <button
                type="button"
                className={networkEnv === "mainnet" ? "net-btn active" : "net-btn"}
                onClick={() => {
                  setNetworkEnv("mainnet");
                  onNetworkEnvChange("mainnet");
                }}
              >
                مین‌نت
              </button>
            </div>
            <span className={sessionOn ? "pill on" : "pill out"}>
              {sessionOn ? username || "on" : "—"}
            </span>
            {sessionOn && (
              <button type="button" className="icon-btn danger-btn" onClick={onLogout}>
                خروج
              </button>
            )}
          </div>
        </header>
        <main className="shell-main">{children}</main>
      </div>
    </div>
  );
}
